module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-3@3x.ver2_0_2.jpg?fd9d0495";